import { useEffect, useState } from "react";
import { api } from "@/lib/soul";
import { Sun } from "lucide-react";

const IMG =
  "https://images.unsplash.com/photo-1773311177903-3faaa3fbc251?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxjYWxtJTIwcXVpZXQlMjBuYXR1cmUlMjBtaXJyb3J8ZW58MHx8fHwxNzg1MzQ4OTY2fDA&ixlib=rb-4.1.0&q=85";

export default function CommonThread() {
  const [intro, setIntro] = useState("");
  const [traditions, setTraditions] = useState([]);

  useEffect(() => {
    api.get("/traditions").then((r) => {
      setIntro(r.data.intro);
      setTraditions(r.data.traditions || []);
    });
  }, []);

  return (
    <main data-testid="common-thread-page">
      <section className="relative rounded-b-[2.5rem] overflow-hidden">
        <img src={IMG} alt="Misty river reflection" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#110D14] via-[#110D14]/85 to-[#110D14]/50" />
        <div className="relative z-10 max-w-5xl mx-auto px-6 pt-24 pb-16">
          <p className="text-[#D4AF37] tracking-[0.3em] uppercase text-xs mb-5 flex items-center gap-2">
            <Sun size={14} /> The Common Thread
          </p>
          <h1 className="serif text-4xl sm:text-6xl lg:text-7xl font-light text-[#F5F1E7] leading-[1.05]">
            One Light, <span className="italic-serif text-[#D4AF37]">many names.</span>
          </h1>
          <p className="mt-8 text-lg text-[#A8A29E] leading-relaxed max-w-2xl">{intro}</p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-2 gap-6" data-testid="traditions-grid">
          {traditions.map((t, i) => (
            <div
              key={i}
              data-testid={`tradition-${i}`}
              className="glass rounded-2xl p-8 hover:border-[#D4AF37]/40 transition-colors duration-300"
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              <div className="flex items-baseline justify-between gap-3">
                <h2 className="serif text-3xl text-[#F5F1E7]">{t.tradition}</h2>
                <span className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] text-right">{t.divine_name}</span>
              </div>
              <p className="mt-4 text-[#A8A29E] leading-relaxed">
                <span className="text-[#F5F1E7]">The goal:</span> {t.goal}
              </p>
              <blockquote className="mt-5 italic-serif text-2xl text-[#D4AF37] leading-snug">
                “{t.teaching}”
              </blockquote>
              <p className="mt-2 text-sm text-[#A8A29E]">— {t.reference}</p>
              <div className="mt-5 border-t border-white/5 pt-4">
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#A8A29E] mb-1">The shared essence</p>
                <p className="text-[#F5F1E7] leading-relaxed">{t.essence}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 glass rounded-2xl p-10 sm:p-14 text-center" data-testid="common-thread-closing">
          <p className="italic-serif text-2xl sm:text-4xl text-[#F5F1E7] leading-snug max-w-3xl mx-auto">
            Different rivers, one sea. However you were taught to name the Light, the invitation is
            the same — to return to the presence of the One who made you.
          </p>
          <p className="mt-6 text-[#D4AF37] tracking-wide">— Mirrors of Your Soul</p>
        </div>
      </section>
    </main>
  );
}
